import { gql } from '@apollo/client';
import { CAR_DETAIL_FRAGMENT } from '../../../common/graphqlQueries/fragments';

export const GET_JOB_CARD_FOR_USER_V2 = gql`    
    query jobCardsForUserQuery($page: Int, $search: String, $filters: [FilterInputType!], $workshopId: String!, $orderBy: String) {
        getRefurbCarListingV2(page: $page, search: $search, filters: $filters, orderBy: $orderBy, workshopId: $workshopId){
            data{
                id
                orderId
                requestSlug
                isBayLayoutEnabled
                isSparePartsServiceAvailable
                isJoblistUnholdableFromWorkshopDashboard
                jobList{
                  id
                  jobCardStatus{
                      label
                      color
                  }
                  sansPodJobCardStatus{
                    label
                    color
                  }
                  inspectionStatus
                }
                assignedCgt{
                    id
                    fullName
                }
                workshop {
                    id
                    name
                    displayName
                }
                jobListTatData {
                  estimated
                  actual
                }
                car {
                    id
                    objectId
                    model
                    make
                    registrationNo
                    variant
                    year
                    mileage
                    transmission
                    procCategory
                }
                createdAt
                currentPodTechnicianNameAndAssignTime {
                    label
                    color
                }
                isTechnicianSuggestable
                technicianManualAssignment
                getActiveJoblist {
                  id
                  isJoblistOnHold
                  joblistOnHoldReason
                  carComplexityForBayJoblist
                  workshopBayType{
                    id
                  }
                }
                refurbCategory
                podVerifierData {
                  isPodVerifierAssignable
                  isPodVerifierReassignable
                  currentPodVerifierName
                  currentPodVerifierId
                  currentPodVerifierAssignedDatetime
                }
                refurbCarWorkshopStatus
                workshopRefurbCarPodAndStatus {
                  groupName
                  podName
                  status
                }
            }
            paginator{
                totalItems
                perPage
                numPages
                currentPage
            }
        }
    }
`;

export const GET_INSPECTOR_LIST = gql`
  query getInspectorList($workshopId: String!) {
    getInspectors(workshopId: $workshopId) {
      id
      fullName
    }
  }
`;

export const GET_POD_LISTING = gql`
    query getPodListingForWorkshop($workshopId: String!) {
        getPodListingForWorkshop(workshopId: $workshopId) {
            podValue
            name
        }
    }
`;

export const GET_TECHNICIANS_FOR_CURRENT_POD = gql`
  query getTechnicianUsersForCurrentPod($refurbCarId: String!) {
    getTechnicianUsersForCurrentPod(refurbCarId: $refurbCarId) {
      id
      username
      fullName
      totalCurrentJoblistsAssignedToTechnician
    }
  }
`

export const GET_ALL_WORKSHOP_POD_VERIFIERS = gql`
  query getAllWorkshopPodVerifiers($workshopId: String!) {
    getAllWorkshopPodVerifiers(workshopId: $workshopId) {
      id
      fullName
      username
    }
  }
`

export const GET_ALL_POD_VERIFIERS = gql`
  query getAllPodVerifiers($refurbCarId: String!, $workshopId: String!, $page: Int, $search: String) {
    getAllPodVerifiers(refurbCarId: $refurbCarId, workshopId: $workshopId, page: $page, search: $search) {
      data {
        userId
        fullName
        podVerifierWorkCount
      }
      paginator{
        totalItems
        perPage
        numPages
        currentPage
      }
    }
  }
`

export const GET_WORKSHOP_BAY = gql`
  query getWorkshopBay($workshopId: String!, $workshopBayTypeId: String!) {
    getWorkshopBay(workshopId: $workshopId, workshopBayTypeId: $workshopBayTypeId){
      id
    }
  }
`

export const GET_TECHNICIANS_LIST = gql`
  query getAllWorkshopTechnicians($workshopId: String!) {
    getAllWorkshopTechnicians(workshopId: $workshopId) {
      id
      fullName
    }
  }
`;
